/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SnapClaimUnflagRequest = {
    resolutionStatus: SnapClaimUnflagRequest.resolutionStatus;
    feedbackId: number;
};

export namespace SnapClaimUnflagRequest {

    export enum resolutionStatus {
        PENDING = 'PENDING',
        CONFIRMED = 'CONFIRMED',
        PARTIALLY_CONFIRMED = 'PARTIALLY_CONFIRMED',
        DECLINED = 'DECLINED',
    }


}

